import { useQuery } from 'react-query'
// @ts-expect-error — importing js
import { request } from '../../../sharedLegacy/utils'
import { type LiveSchedulesDTO } from './liveSchedule'

const SCHEDULE_LIVE_KEY = 'schedule_live_key'

const useSchedule = (liveId?: number, token?: string) => {
  return useQuery({
    queryKey: [SCHEDULE_LIVE_KEY, liveId],
    queryFn: async () => {
      if (!liveId || !token) return null

      const { liveschedules: liveSchedules } = (await request({
        url: '/api/live/schedule/list',
        method: 'POST',
        data: {
          live_id: liveId,
          token,
        },
      })) as LiveSchedulesDTO

      return liveSchedules.find(
        (liveSchedule) => +liveSchedule.live_id === liveId
      )
    },
    cacheTime: Infinity,
    staleTime: Infinity,
  })
}

export { useSchedule }
